module.exports = __webpack_public_path__ + "static/img/banner-session-bienvenida-768x1024.c27d929.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banners/banner-session-bienvenida-768x1024.jpg
// module id = j1JT
// module chunks = 47